<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      isLoading: false,
      optionAtasan: [],
      optionBawahan: [],
      selected: {
        atasan: null,
        bawahan: [],
      },
      form: {
        id_atasan: null,
        idpegawai_internal: null,
        jenis_atasan: "",
      },
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        if (this.mode === "edit" && this.data) {
          const existingBawahan = (
            this.data.bawahan ??
            this.data.pegawai_bawahan ??
            []
          ).map((b) => ({
            idpegawai_internal:
              b.idpegawai_internal ?? b.pegawai_internal?.idpegawai_internal,
            nama: b.nama ?? b.pegawai_internal?.nama ?? "",
            u_nip: b.u_nip ?? b.pegawai_internal?.u_nip ?? "",
          }));

          this.form = {
            id_atasan: this.data.id_atasan,
            idpegawai_internal: this.data.idpegawai_internal,
            jenis_atasan: this.data.jenis_atasan ?? "",
          };
          this.selected.atasan = {
            idpegawai_internal: this.data.idpegawai_internal,
            nama:
              this.data.pegawai_internal?.nama ?? this.data.atasan?.nama ?? "",
          };
          this.selected.bawahan = existingBawahan;
        } else {
          this.resetForm();
        }

        this.getAtasan();
        this.getBawahanBelumAtasan();
      } else {
        this.resetForm();
      }
    },

    "selected.atasan"(val) {
      this.form.idpegawai_internal = val?.idpegawai_internal ?? null;
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  methods: {
    ensureOptionsSelected(list, ...items) {
      items.filter(Boolean).forEach((item) => {
        const exists = list.some(
          (opt) => opt.idpegawai_internal === item.idpegawai_internal
        );
        if (!exists) list.unshift(item);
      });
    },

    getAtasan(search = "", loading = () => {}) {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/pegawai-internal/search",
        params: { search: search, is_get_all: false, limit: 50 },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionAtasan = res.data?.data ?? [];
          this.ensureOptionsSelected(this.optionAtasan, this.selected.atasan);
          loading(false);
        })
        .catch((err) => {
          console.log("err get atasan:", err);
          loading(false);
        });
    },

    searchAtasan(search, loading) {
      loading(true);
      this.getAtasan(search, loading);
    },

    getBawahanBelumAtasan(search = "", loading = () => {}) {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/pegawai-atasan/pegawai-belum-atasan",
        params: { search: search, per_page: 50, is_get_all: false },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionBawahan = res.data?.data?.data ?? [];
          this.ensureOptionsSelected(this.optionBawahan, ...this.selected.bawahan);
          loading(false);
        })
        .catch((err) => {
          console.log("err get pegawai belum atasan:", err);
          loading(false);
        });
    },

    searchBawahan(search, loading) {
      loading(true);
      this.getBawahanBelumAtasan(search, loading);
    },

    resetForm() {
      this.form = {
        id_atasan: null,
        idpegawai_internal: null,
        jenis_atasan: "",
      };
      this.selected = {
        atasan: null,
        bawahan: [],
      };
    },

    store() {
      if (this.isLoading) return;

      if (!this.form.idpegawai_internal) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Atasan tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      if (this.selected.bawahan.length < 1) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Pilih minimal satu pegawai dibawahnya.",
          showConfirmButton: true,
        });
        return;
      }

      if (!this.form.jenis_atasan) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Jenis Atasan tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      const url =
        this.mode === "edit"
          ? this.BACKEND_URL_VERSION + "master/pegawai-atasan/" + this.form.id_atasan
          : this.BACKEND_URL_VERSION + "master/pegawai-atasan";

      const method = this.mode === "edit" ? "put" : "post";

      const payload = {
        idpegawai_internal: this.form.idpegawai_internal,
        jenis_atasan: this.form.jenis_atasan,
        bawahan: this.selected.bawahan.map((item) => item.idpegawai_internal),
      };

      this.isLoading = true;
      axios({
        method,
        url,
        data: payload,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              res.data?.meta?.message ||
              (this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan"),
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$emit("close");
          this.$emit("finish");
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text:
              err.response?.data?.data ||
              err.response?.data?.meta?.message ||
              "Terjadi kesalahan.",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }, // end of store
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="mode === 'edit' ? 'Edit Pegawai Atasan' : 'Tambah Pegawai Atasan'"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">

      <b-form-group label="Atasan" class="fw-medium">
        <v-select
          :options="optionAtasan"
          label="nama"
          :get-option-key="(option) => option.idpegawai_internal"
          v-model="selected.atasan"
          placeholder="Cari Pegawai untuk dijadikan Atasan"
          :filterable="false"
          @search="searchAtasan"
        >
          <template #option="option">{{ option.nama }} - {{ option.u_nip }}</template>
          <template #selected-option="option">{{ option.nama }} - {{ option.u_nip }}</template>
          <template #no-options>Ketik untuk mencari pegawai...</template>
        </v-select>
      </b-form-group>

      <b-form-group label="Pegawai Dibawahnya" class="fw-medium">
        <v-select
          :options="optionBawahan"
          label="nama"
          :get-option-key="(option) => option.idpegawai_internal"
          v-model="selected.bawahan"
          placeholder="Cari Pegawai Dibawahnya"
          multiple
          :filterable="false"
          @search="searchBawahan"
        >
          <template #option="option">{{ option.nama }} - {{ option.u_nip }}</template>
          <template #selected-option="option">{{ option.nama }}</template>
          <template #no-options>Ketik untuk mencari pegawai...</template>
        </v-select>
      </b-form-group>

      <b-form-group label="Jenis Atasan" class="fw-medium">
        <b-form-input
          v-model="form.jenis_atasan"
          type="text"
          placeholder="Masukkan Jenis Atasan"
        ></b-form-input>
      </b-form-group>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary" :disabled="isLoading">
          <span v-if="isLoading">
            <i class="fa fa-spinner fa-spin me-1"></i> Menyimpan...
          </span>
          <span v-else>Simpan</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
